/**
 * 全部资源
 * created by yxy
 *
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';

import BaseComponent from "../../../../base/BaseComponent";
import {Button, message, Divider, Popover, Progress} from 'antd';
import NewFolder from '../../components/NewFolder'
import Delete from '../../components/Delete'
import SetLabel from '../../components/SetLabel'
import SelectPublic from '../../components/Select'
import ComponentsList from '../../components/ComponentsList'
import UploadStatus from '../../components/UploadStatus'
import {HEADER_HEIGHT} from "../../../../constants";
export default class Resource extends BaseComponent {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {

        super(props);
        this.state = {
            btnStatus: false,
            currentId: '',//当前点击的id
            checkArray: [],//选中的数组
            resourceName: '',
            btnNames: [],
            Btn: [],
            // fileList: [],
            Subdirectory: false,
            moreVisible: false,
            queryName: '',
            isClose: true,//控制上传弹框是否显示
            statusKey:'',
            startTime:'',
            endTime:'',
            isDisabled:false
    }
    }

    componentWillMount() {
    }

    componentDidMount() {
        let resource = this.props.match.params.resource;
        this.setState({resource: resource,});
        this.getResourceName(resource);
        this.getResourceBtn(resource)
    }

    componentWillReceiveProps(nextProps, nextContext) {
        if (parseInt(this.state.resource) !== nextProps.match.params.resource) {
            // this.setState({fileList:[]});
            let resource = nextProps.match.params.resource;
            this.getResourceName(resource);
            this.getResourceBtn(resource);
            this.initSelect();
            this.init()
        }
    }

    getResourceName(resource) {
        this.setState({resourceName: resource, queryName: '', Subdirectory: false}, () => {
            this.refreshTable()
        })
    }

    getResourceBtn(resource) {
        let btnNames = [];
        let Btn = [];
        if (resource === 'all') {
            let btn = [[], ["MyUpload", "NewFolder", "Partake", "DownLoad", "Delete", "Rename", "Move", "SetLabel", "IsOpen"]]
            if (this.state.btnStatus) {
                btnNames = btn[1]
            } else {
                btnNames = btn[0]
            }
        } else if (resource === 'public') {
            let btn = [[], ["Partake", "DownLoad", "AskFor"]];
            if (this.state.btnStatus) {
                btnNames = btn[1]
            } else {
                btnNames = btn[0]
            }
        } else if (resource === 'dept') {
            btnNames = ["MyUpload", "NewFolder", "Partake", "DownLoad", "Delete", "Rename", "Move", "SetLabel", "IsOpen"];
        } else if (resource === 'person') {
            btnNames = ["MyUpload", "NewFolder", "Partake", "DownLoad", "Delete", "Rename", "Move", "SetLabel", "IsOpen"];
        }
        this.setState({btnNames: btnNames, Btn: Btn,})
    }

    render() {
        let height = document.body.clientHeight - HEADER_HEIGHT -32;
        return (
            <div style={{
                background: '#ffffff',
                padding: '0 15px',
                margin: "15px 0 15px 15px",
                maxHeight: height,
                position: 'relative',
                borderRadius:5,
                paddingBottom: "15px",
            }}>
                {/*渲染功能按钮*/}
                {this.renderBtn()}
                {this.renderData()}
                {/*{this.renderUploding()}*/}
            </div>
        )
    }

    renderUploding() {
        return(<UploadStatus fileList={this.state.fileList} visible={this.state.fileList.length?true:false} cancelUpload={this.cancelUpload} callBack={(fileList)=>{this.setState({fileList:fileList})}}></UploadStatus>)
    }
    //取消上传
    cancelUpload=(file)=>{
        console.log(this.MyUpload)
        this.MyUpload.cancelUpload(file)
    };
    renderData() {
        return (
            <ComponentsList name={this.state.resourceName}
                            statusKey={this.state.statusKey}
                            btnNames={this.state.btnNames}
                            ref={(ComponentsList) => {
                                this.ComponentsList = ComponentsList
                            }}
                            updateBtnStatus={(data) => {
                                let resource = this.props.match.params.resource;
                                this.setState({btnStatus: data}, () => {
                                    this.getResourceBtn(resource)
                                })
                            }}
                            isDisabled={(data)=>{
                                this.select.isDisabled(data)
                            }}
                            empty={() => {
                                this.initSelect()
                            }}
                            callBack={(currentId, current, checkArray) => {
                                this.state.currentId = currentId
                                this.state.current = current
                                this.state.checkArray = checkArray
                                this.setState({}, () => {
                                    this.hiddenMoreVisible()
                                })
                            }}
            ></ComponentsList>
        )
    }

    renderBtn() {
        let left = '';
        let clientWidth = document.body.clientWidth;
        if (clientWidth >= 1920) {
            left = 140
        } else if (clientWidth < 1920) {
            left = 40
        };
        let width = document.body.clientWidth - 2 * left - 245 - 560;
        let num = Math.floor(width / 120);
        let {btnNames} = this.state;
        let array = btnNames.slice(0, num);
        let newArray = btnNames.slice(num);
        let content = <div style={{lineHeight: '40px'}}>
            {newArray && newArray.length > 0 && newArray.map((item, index) => {
                let ItemComponent = require(`../../components/${item}.js`);
                let ItemComponentDefault = ItemComponent.default;
                return <ItemComponentDefault
                    currentId={this.state.currentId}
                    resourceName={this.state.resourceName}
                    UpLoadType={0}
                    hideCallBack={() => {
                      this.setState({moreVisible:false})
                    }}
                    current={this.state.current} key={item} checkArray={this.state.checkArray}
                    callBack={() => {
                        this.refurbish()
                    }}/>;
            })}
        </div>;
        return (
            <div style={{display: 'flex', paddingTop: 24, justifyContent: 'space-between'}}>
                <div style={{display: 'flex', width: width,height:'30px'}}>
                    {
                        array && array.length > 0 && array.map(item => {
                            let ItemComponent = require(`../../components/${item}.js`);
                            let ItemComponentDefault = ItemComponent.default;
                            return <ItemComponentDefault currentId={this.state.currentId}
                                                         ref={(ref) => {this[item] = ref}}
                                                         UpLoadType={0}
                                                         cancelUpload={this.cancelUpload}
                                                         resourceName={this.state.resourceName}
                                                         current={this.state.current} key={item}
                                                         uplodCallBack={(fileList) => {
                                                             // this.setState({fileList}, () => {
                                                                 // this.refreshList()
                                                             // })
                                                         }}
                                                         hideCallBack={() => {
                                                             this.setState({moreVisible: false})
                                                         }}
                                                         checkArray={this.state.checkArray}
                                                         callBack={() => {
                                                             this.refurbish()
                                                         }}/>;
                        })
                    }
                    {
                        newArray && newArray.length > 0 ? <Popover placement="rightTop"
                                                                   onVisibleChange={(visible) => this.hiddenMoreVisible(visible)}
                                                                   visible={this.state.moreVisible}
                                                                   content={content} trigger="hover">
                            <Button icon={"more"}></Button>
                        </Popover> : null
                    }
                </div>
                <div style={{width: '520px'}}>
                    <SelectPublic ref={(select) => {
                        this.select = select
                    }}
                    // isDisabled={this.state.isDisabled}
                    callBack={(data) => {
                         this.setData(data)
                    }}></SelectPublic>

                </div>
            </div>
        )
    }


    hiddenMoreVisible(visible) {
        this.setState({
            moreVisible: visible,
        });
    };

    refurbish(currentId, current, checkArray,isRefresh,IsGoToPage){
        // this.ComponentsList.refreshList(currentId, current, checkArray,isRefresh,IsGoToPage)
      this.ComponentsList.refreshList()
    }

    refreshTable() {
        this.ComponentsList.getRootName()
    }

    refreshList(queryName, startTime, endTime, Subdirectory) {
        this.ComponentsList.getList(queryName, startTime, endTime, Subdirectory,true)
    }
    // 塞数据
    setData=(data)=>{
        this.ComponentsList.setData(data)
    };
    // 初始化数据
    init(){
        this.ComponentsList.init()
    }
    initSelect(){
        this.select.init()
    }
}




